// adjustHeight is the function that makes the objects squares
// (by setting each one's height equal to its width)
function adjustHeight() {
	var myWidth = $('.large--one-quarter').width();
	var myString = myWidth + 'px';
	$('.large--one-quarter').css('height', myString);
	return myWidth;
}

// calls adjustHeight on window load
jQuery(window).load(function() {
	adjustHeight();
});

// calls adjustHeight anytime the browser window is resized
jQuery(window).resize(function() {
	adjustHeight();
});

